import { styled } from 'styles';
import typography from 'styles/typography';

export const StyledTabsContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
});

export const StyledTabsList = styled('div', {
  display: 'flex',
  borderBottom: '1px solid $dbGray1',
});

export const StyledTabPanel = styled('div', {
  padding: 16,
  display: 'flex',
  backgroundColor: 'white',
});

export const StyledTab = styled('div', {
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  padding: 8,
  backgroundColor: 'white',
  borderTopLeftRadius: 12,
  borderTopRightRadius: 12,
  minWidth: 200,
  justifyContent: 'center',
  '@md': {
    minWidth: 250,
  },
  '@lg': {
    '&:hover': {
      opacity: 0.4,
    },
  },
  variants: {
    isDisabled: {
      true: {
        cursor: 'not-allowed',
      },
    },
    isSelected: {
      true: {
        borderBottomColor: '$info',
        borderBottomWidth: 2,
        borderBottomStyle: 'solid',
        color: '$info',
      },
      false: {
        color: '$typeGray',
      },
    },
  },
});

export const TabBadge = styled('div', {
  borderRadius: 999,
  backgroundColor: '$error',
  ...typography.body5,
  fontWeight: 600,
  color: '$white',
  ml: 8,
  padding: 4,
  height: 25,
  width: 25,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});
